"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _helpers = require("vuelidate/lib/validators/common");

var _default = value => {
  // required
  if (value === undefined || value === null) {
    return true;
  }

  // minimum length of 8
  if (_helpers.len(value) < 8) {
    return false;
  }

  // minimum of 1 lowercase letter
  if (!/[a-z]/.test(value)) {
    return false;
  }

  // minimum of 1 uppercase letter
  if (!/[A-Z]/.test(value)) {
    return false;
  }

  // minimum of 1 number
  if (!/\d/.test(value)) {
    return false;
  }

  return true;
};

exports.default = _default;
